<div class="clearfix"></div>
<div class="container-fluid px-0">
  <div class="main-row">
      <!-- <nav class="text-white col-md-2 px-0 sidebar-container navbar-light" id="sideNavbar">
          <button class="custom-navbar-toggler bg-transparent border-0" type="button" data-toggle="custom-collapse" data-target="#sideNavbar" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
          </button>
          <div class="sidebar-sticky">
              <ul class="nav flex-column mt-5">
                  <li class="nav-item px-3 active">
                      <a class="nav-link d-flex text-nowrap border-bottom border-light py-3" href="#">
                          <span style="background: #5E5E5E;" class="menu-badge"></span> Groups & Tasks
                      </a>
                  </li>
                  <li class="nav-item px-3">
                      <a class="nav-link d-flex text-nowrap border-bottom border-light py-3" href="empty.html">
                          <span style="background: #238c4a;" class="menu-badge"></span> To-do List
                      </a>
                  </li>
                  <li class="nav-item px-3">
                      <a class="nav-link d-flex text-nowrap border-bottom border-light py-3" href="#">
                          <span class="menu-badge"></span> Approvals
                      </a>
                  </li>
                  <li class="nav-item px-3">
                      <a class="nav-link d-flex text-nowrap border-bottom border-light py-3" href="#">
                          <span class="menu-badge"></span> Completed Tasks
                      </a>
                  </li>
                  <li class="nav-item px-3">
                      <a class="nav-link d-flex text-nowrap border-bottom border-light py-3" href="#">
                          <span class="menu-badge"></span> Tasks Via Smart Doc
                      </a>
                  </li>
                  <li class="nav-item px-3">
                      <a class="nav-link d-flex text-nowrap border-bottom border-light py-3" href="#">
                          <span class="menu-badge"></span> Follow-up Tasks
                      </a>
                  </li>
                  <li class="nav-item px-3">
                      <a class="nav-link d-flex text-nowrap border-bottom border-light py-3" href="#">
                          <span class="menu-badge"></span> Sent for Follow-up
                      </a>
                  </li>
                  <li class="nav-item px-3">
                      <a type="button" class="nav-link d-flex text-nowrap border-bottom border-light py-3" data-toggle="modal" data-target="#exampleModal">
                          <img src="../../images/add.png" height="24" class="mr-3"> New Tile
                      </a>
                  </li>
              </ul>
          </div>
          <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable text-body">
                  <div class="modal-content">
                      <div class="modal-header border-0">
                          <h5 class="modal-title" id="exampleModalLabel">Create New Tile</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                          </button>
                      </div>
                      <form>
                          <div class="modal-body">
                              <div class="form-group">
                                  <label for="inputTilename">Tile Name</label>
                                  <input type="text" class="form-control bg-light border-0" id="inputTilename" placeholder="Enter a name for this tile.">
                              </div>
                              <div class="form-row">
                                  <div class="form-group col-md-6">
                                      <label for="inputAssignedBy">Assigned By</label>
                                      <select id="inputAssignedBy" class="form-control bg-light border-0 select2-user">
                                          <option selected="" value="inprogress">Assign a user</option>
                                          <option data-img="../../images/fa.png" value="Fibeesh Aboobacker">Fibeesh Aboobacker</option>
                                          <option data-img="../../images/ms.png" value="Mohammad Saim">Mohammad Saim</option>
                                      </select>
                                  </div>
                                  <div class="form-group col-md-6">
                                      <label for="inputAssignedTo">Assigned To</label>
                                      <select id="inputAssignedTo" class="form-control bg-light border-0 select2-user">
                                          <option selected="" value="inprogress">Assign a user</option>
                                          <option data-img="../../images/fa.png" value="Fibeesh Aboobacker">Fibeesh Aboobacker</option>
                                          <option data-img="../../images/ms.png" value="Mohammad Saim">Mohammad Saim</option>
                                      </select>
                                  </div>
                              </div>
                              <div class="mb-1">Due Date</div>
                              <div class="form-group">
                                  <div class="form-check form-check-inline">
                                      <input class="form-check-input form-pillcheck-input" type="radio" name="duedate" id="duedate1" value="option1" checked>
                                      <label class="form-check-label form-pillcheck-label" for="duedate1">
                                          Today
                                          <svg width="17px" height="12px" class="form-pillcheck-icon" viewBox="0 0 17 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                                  <g id="Homepage-(2)-(12)" transform="translate(-530.000000, -599.000000)" stroke="#FFFFFF" stroke-width="1.88571429">
                                                      <g id="Form" transform="translate(443.000000, 165.000000)">
                                                          <g id="Dates" transform="translate(25.000000, 382.000000)">
                                                              <g id="Group-8" transform="translate(0.000000, 37.000000)">
                                                                  <g id="Group-14" transform="translate(63.000000, 16.000000)">
                                                                      <path d="M0.36307115,4.11459183 L3.77142857,9.01528682 M14.1428571,0.942857143 L3.85834326,9.10503401" id="Combined-Shape"></path>
                                                                  </g>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </g>
                                              </g>
                                          </svg>
                                      </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                      <input class="form-check-input form-pillcheck-input" type="radio" name="duedate" id="duedate2" value="option2">
                                      <label class="form-check-label form-pillcheck-label" for="duedate2">
                                          This Week
                                          <svg width="17px" height="12px" class="form-pillcheck-icon" viewBox="0 0 17 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                                  <g id="Homepage-(2)-(12)" transform="translate(-530.000000, -599.000000)" stroke="#FFFFFF" stroke-width="1.88571429">
                                                      <g id="Form" transform="translate(443.000000, 165.000000)">
                                                          <g id="Dates" transform="translate(25.000000, 382.000000)">
                                                              <g id="Group-8" transform="translate(0.000000, 37.000000)">
                                                                  <g id="Group-14" transform="translate(63.000000, 16.000000)">
                                                                      <path d="M0.36307115,4.11459183 L3.77142857,9.01528682 M14.1428571,0.942857143 L3.85834326,9.10503401" id="Combined-Shape"></path>
                                                                  </g>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </g>
                                              </g>
                                          </svg>
                                      </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                      <input class="form-check-input form-pillcheck-input" type="radio" name="duedate" id="duedate3" value="option3">
                                      <label class="form-check-label form-pillcheck-label" for="duedate3">
                                          This Month
                                          <svg width="17px" height="12px" class="form-pillcheck-icon" viewBox="0 0 17 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                                  <g id="Homepage-(2)-(12)" transform="translate(-530.000000, -599.000000)" stroke="#FFFFFF" stroke-width="1.88571429">
                                                      <g id="Form" transform="translate(443.000000, 165.000000)">
                                                          <g id="Dates" transform="translate(25.000000, 382.000000)">
                                                              <g id="Group-8" transform="translate(0.000000, 37.000000)">
                                                                  <g id="Group-14" transform="translate(63.000000, 16.000000)">
                                                                      <path d="M0.36307115,4.11459183 L3.77142857,9.01528682 M14.1428571,0.942857143 L3.85834326,9.10503401" id="Combined-Shape"></path>
                                                                  </g>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </g>
                                              </g>
                                          </svg>
                                      </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                      <input class="form-check-input form-pillcheck-input" type="radio" name="duedate" id="duedate4" value="option4">
                                      <label class="form-check-label form-pillcheck-label" for="duedate4">
                                          Overdue
                                          <svg width="17px" height="12px" class="form-pillcheck-icon" viewBox="0 0 17 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                                  <g id="Homepage-(2)-(12)" transform="translate(-530.000000, -599.000000)" stroke="#FFFFFF" stroke-width="1.88571429">
                                                      <g id="Form" transform="translate(443.000000, 165.000000)">
                                                          <g id="Dates" transform="translate(25.000000, 382.000000)">
                                                              <g id="Group-8" transform="translate(0.000000, 37.000000)">
                                                                  <g id="Group-14" transform="translate(63.000000, 16.000000)">
                                                                      <path d="M0.36307115,4.11459183 L3.77142857,9.01528682 M14.1428571,0.942857143 L3.85834326,9.10503401" id="Combined-Shape"></path>
                                                                  </g>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </g>
                                              </g>
                                          </svg>
                                      </label>
                                  </div>
                              </div>
                              <div class="mb-1">Color Theme</div>
                              <div class="form-group">
                                  <div class="form-check form-check-inline">
                                      <input class="form-check-input form-circlecheck-input" type="radio" name="colortheme" id="colortheme1" value="option1" checked>
                                      <label class="form-circlecheck-label"style="background: #84B450;" for="colortheme1">
                                          <svg width="17px" height="12px" class="form-circlecheck-icon" viewBox="0 0 17 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                                  <g id="Homepage-(2)-(12)" transform="translate(-530.000000, -599.000000)" stroke="#FFFFFF" stroke-width="1.88571429">
                                                      <g id="Form" transform="translate(443.000000, 165.000000)">
                                                          <g id="Dates" transform="translate(25.000000, 382.000000)">
                                                              <g id="Group-8" transform="translate(0.000000, 37.000000)">
                                                                  <g id="Group-14" transform="translate(63.000000, 16.000000)">
                                                                      <path d="M0.36307115,4.11459183 L3.77142857,9.01528682 M14.1428571,0.942857143 L3.85834326,9.10503401" id="Combined-Shape"></path>
                                                                  </g>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </g>
                                              </g>
                                          </svg>
                                      </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                      <input class="form-check-input form-circlecheck-input" type="radio" name="colortheme" id="colortheme2" value="option2">
                                      <label class="form-circlecheck-label"style="background: #E2A729;" for="colortheme2">
                                          <svg width="17px" height="12px" class="form-circlecheck-icon" viewBox="0 0 17 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                                  <g id="Homepage-(2)-(12)" transform="translate(-530.000000, -599.000000)" stroke="#FFFFFF" stroke-width="1.88571429">
                                                      <g id="Form" transform="translate(443.000000, 165.000000)">
                                                          <g id="Dates" transform="translate(25.000000, 382.000000)">
                                                              <g id="Group-8" transform="translate(0.000000, 37.000000)">
                                                                  <g id="Group-14" transform="translate(63.000000, 16.000000)">
                                                                      <path d="M0.36307115,4.11459183 L3.77142857,9.01528682 M14.1428571,0.942857143 L3.85834326,9.10503401" id="Combined-Shape"></path>
                                                                  </g>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </g>
                                              </g>
                                          </svg>
                                      </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                      <input class="form-check-input form-circlecheck-input" type="radio" name="colortheme" id="colortheme3" value="option3">
                                      <label class="form-circlecheck-label"style="background: #DF6153;" for="colortheme3">
                                          <svg width="17px" height="12px" class="form-circlecheck-icon" viewBox="0 0 17 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                                  <g id="Homepage-(2)-(12)" transform="translate(-530.000000, -599.000000)" stroke="#FFFFFF" stroke-width="1.88571429">
                                                      <g id="Form" transform="translate(443.000000, 165.000000)">
                                                          <g id="Dates" transform="translate(25.000000, 382.000000)">
                                                              <g id="Group-8" transform="translate(0.000000, 37.000000)">
                                                                  <g id="Group-14" transform="translate(63.000000, 16.000000)">
                                                                      <path d="M0.36307115,4.11459183 L3.77142857,9.01528682 M14.1428571,0.942857143 L3.85834326,9.10503401" id="Combined-Shape"></path>
                                                                  </g>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </g>
                                              </g>
                                          </svg>
                                      </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                      <input class="form-check-input form-circlecheck-input" type="radio" name="colortheme" id="colortheme4" value="option4">
                                      <label class="form-circlecheck-label"style="background: #29AADE;" for="colortheme4">
                                          <svg width="17px" height="12px" class="form-circlecheck-icon" viewBox="0 0 17 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                                  <g id="Homepage-(2)-(12)" transform="translate(-530.000000, -599.000000)" stroke="#FFFFFF" stroke-width="1.88571429">
                                                      <g id="Form" transform="translate(443.000000, 165.000000)">
                                                          <g id="Dates" transform="translate(25.000000, 382.000000)">
                                                              <g id="Group-8" transform="translate(0.000000, 37.000000)">
                                                                  <g id="Group-14" transform="translate(63.000000, 16.000000)">
                                                                      <path d="M0.36307115,4.11459183 L3.77142857,9.01528682 M14.1428571,0.942857143 L3.85834326,9.10503401" id="Combined-Shape"></path>
                                                                  </g>
                                                              </g>
                                                          </g>
                                                      </g>
                                                  </g>
                                              </g>
                                          </svg>
                                      </label>
                                  </div>
                              </div>
                          </div>
                          <div class="modal-footer border-0">
                              <button type="button" class="btn btn-white border" data-dismiss="modal">Cancel</button>
                              <button type="submit" class="btn btn-primary">Create</button>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </nav> -->
      <main role="main" class="ml-sm-auto p-0 bg-light main-container">
          <!-- <nav class="navbar navbar-light bg-white border border-right-0">
              <a class="navbar-brand" href="#"><h5 class="m-0 font-weight-bold">TaskX</h5></a>
              <div class="mr-auto">
              </div>
              <form class="form-inline my-2 my-lg-0 pr-3 mr-3 border-right form-search">
                  <button class="border-0 bg-transparent" type="submit">
                      <svg width="16px" height="16px" viewBox="0 0 16 16" class="bi bi-search" fill="#717173" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z" />
                          <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z" />
                      </svg>
                  </button>
                  <input class="form-control mr-sm-2 bg-light" type="search" id="searchControl" placeholder="Search" aria-label="Search">
              </form>
              <a href="">
                  <img class="mr-3 img-fluid" src="../../images/icon-info.png">
              </a>
              <a href="">
                  <img class="mr-3 img-fluid" src="../../images/icon-bell.png">
              </a>
              <a href="">
                  <img class="img-fluid rounded-circle" src="../../images/profile.png">
              </a>
          </nav> -->
          <div class="main-content container-fluid">
              <div class="row">
                  <div class="col">
                      <h2 class="font-weight-bold text-lightdark my-3">Approvals</h2>
                      <div type="button" data-toggle="modal" data-target="#approvalModal" class="card-group-item py-2 px-3 text-body shadow-sm mb-4 bg-white rounded" approval-modal-task="'Design & Development of TaskX Web Version'" approval-modal-assigner="John Smith">
                          <div class="py-2 relative clearfix">
                              <img class="approval-avatar" height="36" src="../../assets/img/fa.png">
                              <div class="pl-5">
                                  <div class="font-weight-lighter">
                                      John Smith <span class="approval-reltime">Just now</span>
                                  </div>
                                  <div class="mt-1">
                                      Invited you to join the group, <b>‘Design & Development of TaskX Web Version’</b>
                                  </div>
                              </div>
                              <div class="approval-timestamp">
                                  18/11/2020 9:00 AM
                              </div>
                          </div>
                      </div>
                      <div type="button" data-toggle="modal" data-target="#approvalModal" class="card-group-item py-2 px-3 text-body shadow-sm mb-4 bg-white rounded" approval-modal-task="'Create web designs for TaskX'" approval-modal-assigner="Fibeesh Aboobacker">
                          <div class="py-2 relative clearfix">
                              <img class="approval-avatar" height="36" src="../../assets/img/fa.png">
                              <div class="pl-5">
                                  <div class="font-weight-lighter">
                                      Fibeesh Aboobacker <span class="approval-reltime">2 hours ago</span>
                                  </div>
                                  <div class="mt-1">
                                      Assigned you the task <b>‘Create web designs for TaskX’</b>
                                  </div>
                              </div>
                              <div class="approval-timestamp">
                                  18/11/2020 7:00 AM
                              </div>
                          </div>
                      </div>
                      <div class="modal fade" id="approvalModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable text-body">
                              <div class="modal-content">
                                  <div class="modal-header border-0">
                                      <h5 class="modal-title" id="exampleModalLabel">Task Assignment</h5>
                                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                          <span aria-hidden="true">×</span>
                                      </button>
                                  </div>
                                  <div class="modal-body">
                                      <span id="approvalModalAssigner"></span> assigned you the task, <b id="approvalModalTask"></b>.
                                  </div>
                                  <div class="modal-footer border-0">
                                      <button type="submit" class="btn btn-white border">Reject</button>
                                      <button type="submit" class="btn btn-primary">Accept</button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="custom-toast-container">
                  <div class="custom-toast green active">
                      <div class="custom-toast-text">
                          You have accepted the task assigned to you.
                      </div>
                      <button type="button" class="ml-2 mb-1 close">
                          <span aria-hidden="true">×</span>
                      </button>
                  </div>
                  <div class="custom-toast red">
                      <div class="custom-toast-text">
                          There was an unexpected error.
                      </div>
                      <button type="button" class="ml-2 mb-1 close">
                          <span aria-hidden="true">×</span>
                      </button>
                  </div>
                  <div class="custom-toast orange">
                      <div class="custom-toast-text">
                          There seems to be problem with the connection.
                      </div>
                      <button type="button" class="ml-2 mb-1 close">
                          <span aria-hidden="true">×</span>
                      </button>
                  </div>
                  <div class="custom-toast blue">
                      <div class="custom-toast-text">
                          An invitation to the group has been sent.
                      </div>
                      <button type="button" class="ml-2 mb-1 close">
                          <span aria-hidden="true">×</span>
                      </button>
                  </div>
                  <div class="custom-toast">
                      <div class="custom-toast-text">
                          This can be used for a default notification.
                      </div>
                      <button type="button" class="ml-2 mb-1 close">
                          <span aria-hidden="true">×</span>
                      </button>
                  </div>
              </div>
          </div>
      </main>
  </div>
</div>
